<template>
  <div class="relative">
    <!-- Hamburger button (mobile only) -->
    <button
      @click="isOpen = !isOpen"
      class="md:hidden p-2 m-2 text-gray-700 rounded hover:bg-gray-200 focus:outline-none"
    >
      🍔 เมนู
    </button>

    <!-- Sidebar -->
    <div
      :class="[
        'fixed top-0 left-0 h-full w-[200px] bg-gray-100 p-4 shadow-md space-y-2 transition-transform duration-300 z-50',
        isOpen ? 'translate-x-0' : '-translate-x-full',
        'md:relative md:translate-x-0 md:block'
      ]"
    >
      <router-link
        to="/"
        class="block px-4 py-2 rounded hover:bg-blue-100 transition"
        :class="{ 'bg-blue-200 font-semibold': $route.path === '/' }"
      >
        Chat
      </router-link>
      <router-link
        to="/promo"
        class="block px-4 py-2 rounded hover:bg-blue-100 transition"
        :class="{ 'bg-blue-200 font-semibold': $route.path === '/promo' }"
      >
        Promo
      </router-link>
      <router-link
        to="/locations"
        class="block px-4 py-2 rounded hover:bg-blue-100 transition"
        :class="{ 'bg-blue-200 font-semibold': $route.path === '/locations' }"
      >
        Locations
      </router-link>
      <router-link
        to="/orders"
        class="block px-4 py-2 rounded hover:bg-blue-100 transition"
        :class="{ 'bg-blue-200 font-semibold': $route.path === '/orders' }"
      >
        Orders
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainSidebar",
  data() {
    return {
      isOpen: false
    };
  }
};
</script>

<style scoped>
/* optional: click outside to close (could use Vue directive or external lib) */
</style>
